(function () {
  'use strict';

  angular
    .module('fertilization.nutrientComparisonExports.edit')
    .config(config);

  function config($stateProvider, permissions) {
    $stateProvider
      .state('fertilization.nutrientComparisonExports.edit', {
        url: '/edit',
        templateUrl: 'fertilization/nutrient-comparison-exports/edit/views/edit.tpl.html',
        controller: 'FertilizationNutrientComparisonExportsEditCtrl',
        controllerAs: 'edit',
        params: {
          message: {
            value: null
          }
        },
        data: {requiredPerms: [
          permissions.FERTILIZATION_CAN_CREATE_NUTRIENT_COMPARISON_EXPORT
        ]}
      });
  }
}());
